<template>
    <div
        class="modal fade bd-example-modal-lg"
        id="Question"
        tabindex="-1"
        role="dialog"
        aria-labelledby="QuestionLabel"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-lg modal-dialog-centered"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="QuestionLabel">Add Question</h5>
                    <div class="question-add-more">
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="emptyData"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="question-scroll">
                        <div>
                            <label for="survey-title" class="col-form-label"
                                >Survey Title:
                                <span class="validate-form">*</span>
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                id="survey-title"
                                v-model="form.survey_title"
                            />
                        </div>
                        <div
                            v-for="(addmore, index) in form.addMore"
                            :key="addmore.id ?? index"
                            class="question-block"
                            ref="questions"
                        >
                            <label class="mb-0 mt-3 col-form-label p-0">
                                Question {{ index + 1 }}
                            </label>

                            <div class="form-group">
                                <div class="question-name-remove">
                                    <label
                                        for="question-name"
                                        class="col-form-label"
                                        >Question name:
                                        <span class="validate-form">*</span>
                                    </label>
                                    <button
                                        class = "btn btn-danger btn-sm"
                                        :class="index === 0 ? 'question-not-allowed' : 'question-pointer'"
                                        :disabled="index === 0"
                                        @click="removeQuestion(index)"
                                    >

                                        Remove Question
                                    </button>
                                </div>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="question-name"
                                    v-model="addmore.question"
                                />
                            </div>
                            <div class="form-group">
                                <div
                                        class="question-option"
                                        v-for="(val, optIndex) in addmore.option"
                                        :key="optIndex"
                                    >
                                    <label class="col-form-label">
                                        Option: {{ optIndex + 1 }} <span class="validate-form">*</span>
                                    </label>

                                    <div class="question-option">
                                        <input
                                            type="text"
                                            class="form-control question-opt-name"
                                            v-model="val.value"
                                        />

                                        <!-- ADD OPTION -->
                                        <button
                                            v-if="optIndex === addmore.option.length - 1"
                                            class="question-opt-plus btn btn-primary"
                                            :disabled="!val.value"
                                            @click.prevent="addOption(index)"
                                        >
                                        +
                                        </button>

                                        <!-- REMOVE OPTION -->
                                        <button
                                            class="question-opt-minus btn btn-danger"
                                            :disabled="optIndex === 0"
                                            @click.prevent="removeOption(optIndex, index)"
                                        >
                                        -
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div
                                class="form-group"
                                :class="form.addMore.length - 1 && 'showBorder'"
                            >
                                <label for="correct-ans" class="col-form-label"
                                    >Correct answer:
                                    <span class="validate-form">*</span>
                                </label>
                                <select
                                    class="custom-select"
                                    v-model="addmore.correct_option"
                                    >
                                    <option
                                        v-for="(op, index) in addmore.option"
                                        :key="op.id ?? index"
                                        :value="op.value"
                                    >
                                        {{ op.value }}
                                    </option>
                                    </select>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <Loader :show="loaderStatus" />
                    <button
                        class="btn btn-success btn-sm"
                        @click="addMoreQuestion"
                    >
                        Add new question
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="handleSubmit"
                    >
                        Submit questions
                    </button>
                    <button
                        type="button"
                        class="btn btn-secondary btn-sm"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="emptyData"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { Modal } from 'bootstrap';
import Loader from "./pre-loader";
const API_URL = "https://devadmin-api.mymedisage.com/api";

export default {
    props: ["event"],
    components: {
        Loader
    },
    data() {
        return {
            form: {
                questionType: "mcq",
                addMore: [
                    {
                        question: "",
                        option: [
                            {
                                key: 0,
                                value: "",
                            },
                        ],
                        correct_option: "",
                    },
                ],
                survey_title: "",
            },
            questionData: [],
            loaderStatus: false,
        };
    },
    methods: {
        emptyData() {
            this.form.addMore = [
                {
                    question: "",
                    option: [
                        {
                            key: 0,
                            value: "",
                        },
                    ],
                    correct_option: "",
                },
            ];
        },
        async handleSubmit() {
            let isValid = true;
            if (this.form.survey_title == "") {
                this.$toast.open({
                    message: "Please fill survey title",
                    type: "error",
                    position: "top",
                });
                isValid = false;
            }
            for (let index = 0; index < this.form.addMore.length; index++) {
                const item = this.form.addMore[index];
                if (
                    item.question === "" ||
                    item.option.some((opt) => opt.value === "") ||
                    item.correct_option === ""
                ) {
                    this.$toast.open({
                        message:
                            "Please fill in all fields for question " +
                            (index + 1),
                        type: "error",
                        position: "top",
                    });
                    isValid = false;
                }
            }
            if (isValid) {
                await this.postQuestion();
            }
        },
        addMoreQuestion() {
            const option = [
                {
                    key: 0,
                    value: "",
                },
            ];
            this.form.addMore.push({
                question: "",
                option: option,
                correct_option: "",
            });
            this.$nextTick(() => {
                const questions = this.$refs.questions;
                const lastQuestion = questions[questions.length - 1];
                lastQuestion.scrollIntoView({ behavior: "smooth" });
            });
        },
        removeQuestion(index) {
            if (index == 0) return;
            this.form?.addMore.splice(index, 1);
        },
        addOption(key) {
            
            let length = this.form.addMore[key].option.length;
            this.form.addMore[key].option.push({
                key: length,
                value: "",
            });
        },
        removeOption(index, key) {
            if (index == 0) return;
            this.form.addMore[key].option.splice(index, 1);
        },
        async postQuestion() {
            const token = localStorage.getItem("token");
            console.log(token);
            
            this.loaderStatus = true;
            try {
                for (let i = 0; i < this.form.addMore.length; i++) {
                    const question = this.form.addMore[i];
                    console.log(question, "question");
                    let formData = new FormData();
                    formData.append("question", this.form.addMore[i].question);
                    formData.append("question_type", "mcq");
                    formData.append(
                        "options",
                        JSON.stringify(this.form.addMore[i].option)
                    );
                    formData.append(
                        "correct_option",
                        this.form.addMore[i].correct_option
                    );
                    const response = await axios.post(
                        `/question-banks`,
                        formData,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
                    // if (response.status) {
                    //     this.loaderStatus = false;
                    //     this.questionData.push(response?.data?.response);
                    //     console.log(this.questionData, "questiondata api res");
                    //     $("#myModal").modal("hide");
                    // }
                    if (response.status) {
                        this.loaderStatus = false;
                        this.questionData.push(response?.data?.response);
                        console.log(this.questionData, "questiondata api res");

                        const modalEl = document.getElementById('myModal');
                        const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
                        modal.hide();
                    } else {
                        this.$toast.open({
                            message: "Something went wrong",
                            type: "error",
                            position: "top",
                        });
                    }
                }
                this.postCme();
                this.emptyData();
            } catch (err) {
                console.log(err, "error");
                this.$toast.open({
                    message: "Something went wrong",
                    type: "error",
                    position: "top",
                });
                this.loaderStatus = false;
            }
        },
        async postCme() {
            const token = localStorage.getItem("token");
            this.loaderStatus = true;
            try {
                let formData = new FormData();
                formData.append("type", "cme");
                formData.append("name", `${this.form.survey_title ?? ""}`);
                formData.append("description", `${this.event.title ?? ""} CME`);
                formData.append("heading_text", `${this.event.title ?? ""}`);
                formData.append("passing_criteria", "20");
                formData.append("allowed_members_from", "all");
                formData.append("pass_text", "Thank you");
                formData.append("pass_button_text", "Finish");
                formData.append("status", 1);
                const questions = [];
                this.questionData.forEach((c) => {
                    let question = {
                        id: c.id,
                        question: c.question,
                        show_answer: 0,
                        show_answer_details: 0,
                    };
                    questions.push(question);
                });
                const attachment = [
                    {
                        map_type_id: this.event?.id ?? "",
                        map_type: "during_live_event",
                        mapped_id: "",
                        when_to_show: 0,
                    },
                ];
                formData.append("questions", JSON.stringify(questions));
                formData.append("attachments", JSON.stringify(attachment));
                const response = await axios.post(`${API_URL}/cme`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                // if (response.status) {
                //     this.loaderStatus = false;
                //     this.questionData.push(response?.data?.response);
                //     console.log(response, "cme res data");
                //     $("#Question").modal("hide");
                //     this.$toast.open({
                //         message: "Survey added successfully",
                //         type: "success",
                //         position: "top",
                //     });
                //     setTimeout(() => {
                //         window.location.reload();
                //     }, 1000);
                // }
                if (response.status) {
                    this.loaderStatus = false;
                    this.questionData.push(response?.data?.response);
                    console.log(response, "cme res data");

                    const modalEl = document.getElementById('Question');
                    const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
                    modal.hide();

                    this.$toast.open({
                        message: "Survey added successfully",
                        type: "success",
                        position: "top",
                    });

                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    this.$toast.open({
                        message: "Something went wrong",
                        type: "error",
                        position: "top",
                    });
                }
            } catch (err) {
                // console.log(err.response.data, "errrrr************");
                this.$toast.open({
                    message: "Something went wrong",
                    type: "error",
                    position: "top",
                });
                console.log(err);
                this.loaderStatus = false;
            }
            this.loaderStatus = false;
        },
    },
};
</script>

<style scoped>
.question-modal {
    position: fixed;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 50;
    padding: 20px;
    background: white;
    border: 1px solid gray;
    backdrop-filter: blur(2px) brightness(50%);
}

.question-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    border: 1px solid gray;
    color: black;
}

.question-modal-header {
    padding: 10px;
}

.form-control:focus {
    box-shadow: unset !important;
    border-color: unset !important;
    outline: 0 !important;
}

.question-opt-name {
    display: grid;
}

.question-option {
    /* display: grid; */
    grid-template-columns: 1fr 30px 30px;
    grid-gap: 15px;
    align-items: center;
}
.question-option div {
    display: grid;
    grid-template-columns: 1fr 30px 30px;
    grid-gap: 15px;
    align-items: center;
}

.question-opt-plus,
.question-opt-minus {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(1.5em + 0.25rem + 2px);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.question-pointer {
    cursor: pointer;
}

.question-not-allowed {
    cursor: not-allowed;
}

.question-add-more {
    display: flex;
    justify-content: flex-end;
}

.showBorder {
    border-bottom: 2px dashed #a1a0a0;
    padding-bottom: 20px;
}

.question-scroll {
    max-height: 32rem;
    overflow-y: scroll;
    padding-right: 10px;
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-track {
        background: #f1f1f1 !important;
    }
    &::-webkit-scrollbar-thumb {
        background: #888 !important;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555 !important;
    }
}

.question-name-remove {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
}

.validate-form {
    color: red;
    margin-left: 2px;
}
.question-name-remove {
    align-items: center;
    display: flex
;
    justify-content: space-between;
    padding: 10px 0;
}
.btn-danger.disabled, .btn-danger:disabled {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
}
</style>
